<ng-container *ngIf="this.sections.length > 0">
  <span class="text-sub-title fw-bold text-complementary-color-a d-block mx-3 border-top pt-2">
    Action buttons
  </span>

  <div
    class="mx-3 pt-2"
    *ngFor="let section of this.sections"
  >
    <span
      *ngIf="section.section"
      class="d-block text-normal text-complementary-color-a"
    >
      {{section.section}}:
    </span>
    <div
      class="w-100 d-flex justify-content-center align-items-center mt-2 rounded-2 "
      *ngFor="let button of section.buttons; let index=index"
      [ngClass]="{
            'hover:text-white': !loadingBulkActionButton,
            'hover:bg-primary-color': !loadingBulkActionButton,
            'pointer': !loadingBulkActionButton
          }"

      [ngStyle]="{
          backgroundColor: button.color,
          padding: '2px 4px',
          color: button.text_color
          }"
      (click)="dispatchActionButton(button.id)"
    >
      <div
        *ngIf="loadingBulkActionButton === button.id"
        class="spinner-grow spinner-grow-sm me-1" role="status"
      ></div>
      <span
        *ngIf="button.icon && loadingBulkActionButton != button.id"
        class="material-symbols-outlined text-sub-title me-1"
      >
            {{button.icon}}
          </span>
      <span
        class="text-normal user-select-none"
      >
            {{button.label}}
          </span>
    </div>
  </div>


</ng-container>

